<ng-template #cardTemplate>
  @for (item of items | async; track item) {
    <eas-venue-slot [venue]="item"></eas-venue-slot>
  }
</ng-template>

<app-list title="Venues" [cardTemplate]="cardTemplate" [actions]="actions" i18n-title></app-list>
